import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useState} from 'react'
import {BiTrash} from 'react-icons/bi'
import {HiArrowRight, HiEnvelope, HiPhone} from 'react-icons/hi2'
import {Link} from 'react-router-dom'
import {CourseActionTypes, enrollment_status_options,} from 'views/AppLocals/Course'
import {useCourse} from 'views/AppLocals/Course/useCourse'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {NullAsDefault, renderElse, renderIf, renderIfElse} from 'views/Shared'
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {ItemInformation} from 'components/common/ItemInformation'
import {Avatar, message} from "antd";
import copyToClipboard from "copy-to-clipboard";
import {IoCopyOutline} from "react-icons/io5";
import {FaUserGraduate} from "react-icons/fa6";
import {IdentifierTypes} from "../../../AppLocals/appFieldTypes";
import getAliasName from "../../../../helpers/getAliasName";
import {BsInfoCircleFill} from "react-icons/bs";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";

const WrapperClassStudent = ({item, index, children}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)

    const {
        course,
        student,
        user,
        patron_saint_name,
        fullname,
        identifier_code,
        identifier_type,
        is_self_reg = 1,

    } = item ?? {}

    return (
        <div key={index} className="p-4 flex flex-col custom-item-render relative list-item">
            <div className="mb-2 pb-2 border-b border-color-50 flex items-center gap-2">
                <Avatar
                    size={40}
                    src={user?.avatar}
                    icon={<FaUserGraduate size={18} className="text-color-500"/>}
                    className="flex flex-center background-200"
                />
                {renderIfElse(
                    _.some([user]),
                    // Đăng ký cho người khác
                    <div className="flex flex-col flex-1 tracking-wide mr-6 md:mr-0">
                        {renderIfElse(
                            !is_self_reg,
                            <div className="space-x-1 text-sm leading-snug tracking-wide">
                                <span className="text-color-300 italic">{t('user')}</span>
                                <Link to={getLinkToDetail(user) || "#"} className="no-underline font-bold text-gray-800">
                                    {renderIf(
                                        getAliasName(user, 'patron_saint'),
                                        <span className="mr-1 font-medium text-gray-600">
                                            {getAliasName(user, 'patron_saint')}
                                        </span>
                                    )}
                                    {getTitle(user)}
                                </Link>
                                <span className="text-color-300 italic lowercase">
                                    {t('registered for the course')}
                                </span>
                                <Link to={getLinkToDetail(course)}
                                      className="font-semibold text-green-600 no-underline">
                                    {getTitle(course)}
                                </Link>
                                <span className="text-color-300 italic lowercase">
                                    {t('for student')}
                                </span>
                                <span className="no-underline font-bold text-gray-800">
                                    {renderIf(
                                        getAliasName(item, 'patron_saint'),
                                        <span className="mr-1 font-medium text-gray-600">
                                            {getAliasName(item, 'patron_saint')}
                                        </span>
                                    )}
                                    {fullname}
                                </span>
                            </div>,
                            <div className="space-x-1 text-sm leading-snug tracking-wide">
                                <Link to={getLinkToDetail(user) || "#"}
                                      className="no-underline font-bold text-gray-800">
                                    {renderIf(
                                        getAliasName(item, 'patron_saint'),
                                        <span className="mr-1 font-medium text-gray-600">
                                            {getAliasName(item, 'patron_saint')}
                                        </span>
                                    )}
                                    {fullname}
                                </Link>
                            </div>
                        )}
                        {renderIf(
                            student && is_self_reg,
                            <div className="space-x-1 text-color-400 tracking-wider">
                                <span className="whitespace-no-wrap">
                                    {!isLg ? '#' : `${t('student code')} : `}
                                </span>
                                <span
                                    onClick={() => {
                                        copyToClipboard(student?.student_idcode)
                                        message.info(t('copied'))
                                    }}
                                    className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                    {student?.student_idcode}
                                    <IoCopyOutline size={12} className="ml-1"/>
                                </span>
                            </div>
                        )}
                    </div>,
                    // Đăng ký cho bản thân
                    <div className="flex flex-col flex-1">
                        <div className="space-x-1 text-base leading-snug tracking-wide">
                            {renderIf(
                                getAliasName(item, 'patron_saint'),
                                <span className="mr-1 font-medium text-gray-600">
                                    {getAliasName(item, 'patron_saint')}
                                </span>
                            )}
                            <span className="font-bold text-gray-800 leading-snug">
                                {fullname}
                            </span>
                        </div>
                        {identifier_code && (
                            <div className="text-color-500 text-xs">
                                <span className="whitespace-no-wrap">
                                    {`${t(_.find(IdentifierTypes, {value: identifier_type})?.label)}: `}
                                </span>
                                <span className="font-mono text-xs text-blue-500 leading-tight">
                                    {identifier_code}
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {children}
        </div>
    )
}

export const CourseEnrollment = ({item, onRefresh = NullAsDefault}) => {
    const t = useTranslate()
    const id = getId(item)
    const [current, setCurrent] = useState('0')

    const {onDeleteEnrollment = NullAsDefault} = useCourse({
        onEnrollmentDeleted: onRefresh,
    })

    const handleAction = (action, params) => {
        switch (action) {
            case CourseActionTypes.ENROLLMENT_DELETE:
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete enrollment',
                    message: 'are you sure you want to delete this enrollment',
                    onOk: () => {
                        onDeleteEnrollment({}, {id: getId(params)})
                    },
                })
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CourseActionTypes.ENROLLMENT_DELETE,
                    },
                ],
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    return renderMyEnrollment({renderContextMenu,})(item, id)
}

export const renderMyEnrollment = ({renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {
        course,
        status, notes,
        registered_subjects = [],
        is_self_reg = 1,
        contact_phone,
        contact_email,
        fullname,
        patron_saint_name,
        enrollment_date,
    } = item ?? {}
    const status_options = Object.values(enrollment_status_options)
    const current_status = _.find(status_options, {value: status}) ?? {}

    return (
        <div
            key={index}
            className="p-4 flex flex-col gap-1 background shadow-md hover:scale-2xs rounded-xl custom-item-render transition-all duration-300 relative">
            {renderIfElse(
                is_self_reg,
                // Đăng ký cho bản thân
                <div className="flex flex-col gap-1">
                    <div className="flex flex-col">
                        <span className="text-color-300 tracking-wider">
                          {t('you have successfully registered for the course')}
                        </span>
                        <Link
                            to={getLinkToDetail(course)}
                            className="font-bold text-lg text-color-000 tracking-wide no-underline leading-snug">
                            {course?.title}
                        </Link>
                    </div>
                    <div className="my-1 border-b border-color-50"/>
                    {(registered_subjects.length > 0 || enrollment_date) && (
                        <>
                            {registered_subjects.length > 0 && (
                                <div className="space-x-1 italic">
                                    <span className="text-color-400">
                                        {`${t('subjects registered')} :`}
                                    </span>
                                    {registered_subjects?.map((e, i) => (
                                        <span key={i} className="font-semibold text-gray-800">
                                            {getTitle(e)} {i < registered_subjects?.length - 1 && ', '}
                                        </span>
                                    ))}
                                </div>
                            )}
                            {enrollment_date && (
                                <ItemInformation
                                    showIcon={false}
                                    label="enrollment date"
                                    value={formatSimplifyDate(enrollment_date)}
                                    className="italic"
                                />
                            )}
                        </>
                    )}
                    {renderIf(
                        notes,
                        <div className="text-xs text-color-400 italic">
                            {notes}
                        </div>
                    )}
                </div>,
                // Đăng ký dùm
                <div className="flex flex-col gap-1">
                    <div className="space-x-1 whitespace-pre-line">
                        <span className="text-color-300 tracking-wider">
                            {t('you have successfully registered for the course')}
                        </span>
                        <Link
                            to={getLinkToDetail(course)}
                            className="font-bold text-lg text-green-600 tracking-wide leading-snug no-underline">
                            {`\n ${course?.title}`}
                        </Link>
                        <span className="text-color-300 tracking-wider lowercase">
                            {`\n ${t('for student')}`}
                        </span>
                    </div>
                    <div className="my-1 border-b border-color-50"/>
                    <div className="flex flex-col gap-1">
                        <div className="flex items-center gap-2">
                            <BsInfoCircleFill size={14} className="text-blue-300"/>
                            <span className="font-bold text-sm text-blue-600 uppercase tracking-wide">
                                {t('student information')}
                            </span>
                        </div>
                        <div className="flex flex-col gap-1">
                            <ItemInformation
                                primary={true}
                                label="full name"
                                value={`${patron_saint_name || ''} ${fullname}`}
                                className="italic"
                            />
                            <DoubleValueItem
                                labelFirst="contact"
                                valueFirst={contact_phone}
                                labelSecond={contact_email ? ' - ' : ''}
                                valueSecond={contact_email}
                                className="italic"
                            />
                            {registered_subjects?.length > 0 && (
                                <div className="space-x-1 italic">
                                    <span className="text-color-400">
                                        {`${t('subjects registered')} :`}
                                    </span>
                                    {registered_subjects?.map((e, i) => (
                                        <span key={i} className="font-semibold text-color-000">
                                            {getTitle(e)} {i < registered_subjects?.length - 1 && ', '}
                                        </span>
                                    ))}
                                </div>
                            )}
                            <ItemInformation
                                label="enrollment date"
                                value={formatSimplifyDate(enrollment_date) || t('not update')}
                                className="italic"
                            />
                        </div>
                    </div>
                    {renderIf(
                        notes,
                        <>
                            <div className="my-1 border-b border-color-50"/>
                            <div className="text-xs text-color-400 italic">
                                {notes}
                            </div>
                        </>
                    )}
                </div>
            )}
            <div style={{position: 'absolute', bottom: 10, right: 10}}>
                <span
                    style={{fontSize: '0.65rem', height: 14}}
                    className={classNames('w-fit flex items-center gap-1 leading-tight', current_status?.className)}>
                    {renderElse(isSm, current_status?.icon)}
                    {renderIf(
                        _.isString(current_status?.label),
                        <span className="font-medium italic">
                            {t(current_status?.label)}
                        </span>
                    )}
                </span>
            </div>
            <div className="absolute top-8 right-8 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}

export const renderCourseEnrollment = ({renderActions = NullAsDefault, renderContextMenu = NullAsDefault, statusFilter, owner_id, hideGotoLink = false} = {}) => (item, index) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {
        student,
        user,
        status,
        course,
        contact_email,
        contact_phone,
        registered_subjects = [],
        is_self_reg = 1,
        fullname,
        patron_saint_name,
        relationship,

        enrollment_date,
        identifier_code, identifier_type,
        parish_name, diocese_name,
        date_of_birth, gender,
    } = item ?? {}

    const status_options = Object.values(enrollment_status_options)
    const current_status = _.find(status_options, {value: status}) ?? {}

    const studentName = [patron_saint_name, fullname].filter(Boolean).join(' ')
    const registrantName = [getAliasName(user, 'patron_saint'), getTitle(user)].filter(Boolean).join(' ')
    const studentPhone = student?.contact_phone || contact_phone
    const studentEmail = student?.contact_email || contact_email

    const orgAlias = course?.owner?.alias || owner_id
    const courseEnrollUrl = course?.id
        ? `/workspace/course?rel=course&org_id=${orgAlias}&course-status=1&current_course_id=${course.id}&course-detail-tab=enrollment`
        : null

    const showStatus = statusFilter === null || statusFilter === undefined

    return (
        <div key={index} className="p-3 flex items-start gap-3 custom-item-render relative list-item">
            <Avatar
                size={36}
                src={user?.avatar}
                icon={<FaUserGraduate size={14} className="text-color-500"/>}
                className="mt-1 flex flex-center background-200 flex-shrink-0"
            />

            <div className="flex flex-col flex-1">
                {/* Ai đăng ký + Khóa học */}
                <div className="space-x-1 pr-6 tracking-wide">
                    {!is_self_reg ? (
                        <span className="space-x-1 text-base leading-snug">
                            {registrantName && (
                                <span className="font-bold text-gray-800">{registrantName}</span>
                            )}
                            {registrantName && (
                                <span className="text-color-300 italic">{t('for student')}</span>
                            )}
                            <span className="font-bold text-gray-800">
                                {studentName}
                            </span>
                        </span>
                    ) : (
                        <span className="text-base font-semibold text-color-000 leading-snug">
                            {studentName}
                        </span>
                    )}
                    <span className="space-x-1 leading-tight">
                        <span className="text-color-300 italic">
                            {t('registered for the course').toLowerCase()}
                        </span>
                        <Link to={getLinkToDetail(course) || '#'} className="font-semibold text-sm text-green-600 no-underline">
                                {getTitle(course)}
                        </Link>
                    </span>
                </div>

                {/* Liên hệ */}
                {(studentPhone || studentEmail) && (
                    <div className="mb-1 flex items-center gap-3 text-blue-500 flex-wrap">
                        {studentPhone && (
                            <span className="flex items-center gap-1 tracking-wider">
                                <HiPhone size={11} className="flex"/> {studentPhone}
                            </span>
                        )}
                        {studentEmail && (
                            <span className="flex items-center gap-1 tracking-wider">
                                <HiEnvelope size={11} className="flex"/> {studentEmail}
                            </span>
                        )}
                    </div>
                )}

                {/* Thông tin khác */}
                <ItemInformation
                    showIcon={true}
                    label={t(_.find(IdentifierTypes, {value: identifier_type})?.label)}
                    value={identifier_code}
                    className="mb-1 text-xs italic tracking-wider"
                />
                <ItemInformation
                    showIcon={true}
                    label="date of birth"
                    value={`${formatSimplifyDate(date_of_birth, '', 'DD/MM/YYYY')} - ${t(getLabelOfGender(gender))}`}
                    className="mb-1 text-xs italic tracking-wider"
                />
                <ItemInformation
                    showIcon={true}
                    label="enrollment date"
                    value={formatSimplifyDate(enrollment_date, 'medium')}
                    className="mb-1 text-xs italic tracking-wider"
                />
                <div className="my-2 border-b border-color-50"/>
                {/* Footer: status + actions + goto */}
                <div className="flex justify-end gap-2">
                    {showStatus && current_status?.label && (
                        <span className={classNames('flex-shrink-0 flex items-center gap-0.5 text-xs', current_status?.className)}>
                            {current_status?.icon}
                            {!isSm && (
                                <span className="font-medium italic">{t(current_status.label)}</span>
                            )}
                        </span>
                    )}
                    <div className="flex items-center gap-2">
                        {renderElse(isSm, renderActions(item))}
                    </div>
                    {!hideGotoLink && courseEnrollUrl && (
                        <Link
                            to={courseEnrollUrl}
                            className="ml-auto no-underline flex items-center gap-1 text-xs font-medium text-indigo-600 hover:text-indigo-700 flex-shrink-0">
                            {t('go to enrollment page')}
                            <HiArrowRight size={11}/>
                        </Link>
                    )}
                </div>
            </div>

            {/* Context menu */}
            <div className="absolute top-5 right-5 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}
